export const removeQueryParameters = (urlString) => {
  const url = new URL(urlString);
  url.search = "";
  console.log("redirectUri:", url.toString());
  return url.toString();
};
